export default __webpack_public_path__ + "static/media/a037-phoneNumber-03.d3584894.png";